import { MatDateFormats } from '@angular/material/core';

/**
 * Custom date formats for Material datepicker
 * These formats control how dates are displayed and parsed
 */
export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'L', // Locale-aware date parsing
  },
  display: {
    dateInput: 'L', // Locale-aware date display (will be handled by CustomDateAdapter)
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
